import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import swiper from 'vue-awesome-swiper'

import "./assets/scss/reset.scss"		// 引入全局重置样式
import "./assets/scss/layout.scss"		// 引入全局响应式布局
import utils from "./plugins/utils.js"   // 引入全局函数
import directives from "./plugins/directives.js"  // 引入自定义指令
// import "./assets/icon/iconfont.css"   // 引入icon图标
import 'swiper/dist/css/swiper.css'   // 引入swiper轮播图
import swal from 'sweetalert'; 

Vue.use(VueAxios,axios)

Vue.use(directives)
Vue.use(swiper, /* { eslint-disable no-new  } */)

Vue.config.productionTip = false
Vue.prototype.$utils = utils

// window.setupLang = setupLang
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

new Vue({
  router,
  store,
 
  render: h => h(App)
}).$mount('#app')
